export const LazyAuthDialogComponents = {
  supportDialog: 'supportDialog',
  loginDialog: 'loginDialog',
  registrationDialog: 'registrationDialog',
  changePasswordDialog: 'changePWDialog',
  resetPasswordDialog: 'resetPWDialog',
  resendVerificationDialog: 'resendVerificationDialog',
  subscriptionInfoDialog: 'subscriptionInfoDialog',
};
